import type { LinkTab } from "@/components/ui/link-tabs";

export type StatsTab = "collection" | "types" | "indicators";

export const STATS_TABS: StatsTab[] = ["collection", "types", "indicators"];

/** Old addresses of the three former pages, relative to /:lang/admin. */
export const LEGACY_STATS_REDIRECTS: Record<string, `stats/${StatsTab}`> = {
  collection: "stats/collection",
  "contributions/stats": "stats/types",
  metrics: "stats/indicators",
};

const LABELS: Record<"fr" | "en", Record<StatsTab, string>> = {
  fr: { collection: "Collecte", types: "Par type", indicators: "Indicateurs" },
  en: { collection: "Collection", types: "By type", indicators: "Indicators" },
};

const ICONS: Record<StatsTab, LinkTab["icon"]> = {
  collection: "activity",
  types: "barChart3",
  indicators: "pieChart",
};

/**
 * The tabs of the statistics page. The period and language chosen on one tab
 * travel in the query string, so they follow when switching tabs.
 */
export function buildStatsTabs(lang: string, search = ""): LinkTab[] {
  const labels = LABELS[lang === "en" ? "en" : "fr"];
  const query = search && !search.startsWith("?") ? `?${search}` : search;
  return STATS_TABS.map((tab) => ({
    key: tab,
    label: labels[tab],
    href: `/${lang}/admin/stats/${tab}${query}`,
    icon: ICONS[tab],
    // Matching ignores the query: the tab stays current whatever the filters.
    match: [`/${lang}/admin/stats/${tab}`],
  }));
}
